export default [
    {
        value: 'P1D',
        label: 'calendar.create_client_repeat_option_every_day',
    },
    {
        value: 'P7D',
        label: 'calendar.create_client_repeat_option_every_week',
    },
    {
        value: 'P14D',
        label: 'calendar.create_client_repeat_option_every_2_week',
    },
    {
        value: 'P21D',
        label: 'calendar.create_client_repeat_option_every_3_week',
    },
    {
        value: 'P28D',
        label: 'calendar.create_client_repeat_option_every_4_week',
    },
    {
        value: 'P1M',
        label: 'calendar.create_client_repeat_option_every_month',
    },
    {
        value: 'P1Y',
        label: 'calendar.create_client_repeat_option_every_year',
    }
];

